const CONST = {
  SYS_ERR: 'システムでエラーが発生しました。 しばらくしてからもう一度お試しください。'
}
export default CONST



// WEBPACK FOOTER //
// ./src/constants/commonText.js